export default "__VITE_ASSET__CYCVSX6A__"